// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
body {
  background-color: #333;
}
::-webkit-scrollbar {
  width: 4px;
  height: 8px;
}
::-webkit-scrollbar-thumb {
  background-color: #888;
  /* Adjust the color as needed */
  border-radius: 5px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #555;
  /* Adjust the hover color as needed */
}
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* Adjust the track color as needed */
}
body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}
.ant-btn-default:not(:disabled):hover,
.ant-btn-default:not(:hover):active {
  color: #47cb38 !important;
  border-color: #47cb38 !important;
}
.ant-btn-primary {
  color: #fff;
  background-color: #47cb38;
}
.ant-btn-primary:not(:disabled):active,
.ant-btn-primary:not(:disabled):hover {
  color: #fff !important;
  background-color: rgba(71, 203, 56, 0.8) !important;
}
.ant-spin-dot-item,
.ant-switch.ant-switch-checked {
  background-color: #47cb38 !important;
}
.ant-btn:disabled {
  background-color: #fff;
  color: rgba(0, 0, 0, 0.5);
}
.ant-pagination.ant-table-pagination {
  background: #fff;
  margin: 0 !important;
  padding: 16px 8px;
}
.ant-pagination-item,
.ant-select.ant-pagination-options-size-changer:hover .ant-select-selector,
.ant-input:hover,
.ant-input:active,
.ant-input:focus,
.ant-upload-wrapper .ant-upload-drag:not(.ant-upload-disabled):hover,
.ant-select:hover .ant-select-selector,
.ant-input-outlined:hover {
  border-color: #47cb38 !important;
}
.ant-pagination-item-active a,
.ant-btn-link,
.ant-tabs-tab-btn:active,
.ant-tabs .ant-tabs-tab:hover,
.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #47cb38 !important;
}
a {
  color: inherit !important;
}
button.unfilledDateButton {
  margin: 1px;
}
a.regular-link {
  color: blue !important;
}
a.regular-link:hover {
  color: blue !important;
  text-decoration: underline;
}
.ant-table-wrapper .ant-table.ant-table-small .ant-table-thead > tr > th {
  padding: 1px;
  /* Even smaller padding for small size table */
}
.ant-menu-dark,
.ant-menu-sub,
.ant-layout-header {
  background: #bb3b3b !important;
  color: #ffffff !important;
}
.ant-menu-item,
.ant-menu-title-content {
  font-size: 16px;
  transition: color 0.1s !important;
}
.ant-menu-submenu-selected,
.ant-menu-item-selected,
.ant-menu-item:active {
  color: #000000;
  background: none !important;
}
.ant-menu-submenu-selected span,
.ant-menu-item-selected span {
  color: #000000;
  font-weight: 600;
}
#google-logout-button {
  background-color: #ffffff;
  color: #000000;
}
.ant-layout-content {
  background: #333333 !important;
  padding: 0 12px;
}
.ant-tabs .ant-tabs-ink-bar.ant-tabs-ink-bar-animated {
  background: #47cb38 !important;
}
#google-signin-div {
  padding: 10px;
}
#google-logout-div {
  display: inline;
  vertical-align: middle;
}
.ant-checkbox-checked .ant-checkbox-inner,
.ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner {
  background-color: #47cb38;
  border-color: #47cb38;
}
.ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner {
  border-color: #47cb38;
}
.ant-checkbox-indeterminate .ant-checkbox-inner:after {
  background-color: #47cb38;
}
.ant-btn-default.ant-btn-dangerous:not(:disabled):not(.ant-btn-disabled):active,
.ant-btn-default.ant-btn-dangerous:not(:disabled):not(.ant-btn-disabled):hover {
  color: #d9363e !important;
  border-color: #d9363e !important;
}
.ant-btn-primary.ant-btn-dangerous:not(:disabled):not(.ant-btn-disabled):hover {
  background-color: #ff7875 !important;
}
.ant-table-wrapper .ant-table-tbody .ant-table-row.ant-table-row-selected > .ant-table-cell {
  background: #e3ffe0 !important;
}
.ant-table-wrapper .ant-table-tbody .ant-table-row.ant-table-row-selected:hover > .ant-table-cell {
  background: #cefdc9 !important;
}
.react-datepicker-popper {
  z-index: 9999 !important;
}
.ant-segmented {
  background: black;
}
.ant-segmented-item-label {
  color: #fff;
}
.ant-segmented-item-selected {
  background-color: #47cb38 !important;
  color: #161010 !important;
}
.ant-segmented-thumb {
  background-color: #47cb38 !important;
}
.ant-select-dropdown .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
  background-color: #d8fcd4;
}
.activeBorderColor {
  border-color: #47cb38 !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/index.less","webpack://./src/assets/styles/theme.less"],"names":[],"mappings":"AAEA;EACC,UAAA;EACA,SAAA;EACA,sBAAA;AADD;AAGA;EACC,sBAAA;AADD;AAIA;EACC,UAAA;EACA,WAAA;AAFD;AAIA;EACC,sBAAA;EAFC,+BAA+B;EAGhC,kBAAA;AADD;AAGA;EACC,sBAAA;EADC,qCAAqC;AACvC;AAEA;EACC,yBAAA;EAAC,qCAAqC;AACvC;AAEA;EACC,SAAA;EACA,UAAA;EACA,8JAAA;EAEA,mCAAA;EACA,kCAAA;AADD;AAIA;EACC,+EAAA;AAFD;AAKA;;EAEC,yBAAA;EACA,gCAAA;AAHD;AAMA;EACC,WAAA;EACA,yBAAA;AAJD;AAMA;;EAEC,sBAAA;EACA,mDAAA;AAJD;AAOA;;EACC,oCAAA;AAJD;AAOA;EACC,sBAAA;EACA,yBAAA;AALD;AAOA;EACC,gBAAA;EACA,oBAAA;EACA,iBAAA;AALD;AAQA;;;;;;;;EAQC,gCAAA;AAND;AASA;;;;;EAKC,yBAAA;AAPD;AAUA;EACC,yBAAA;AARD;AAWA;EACC,WAAA;AATD;AAYA;EACC,sBAAA;AAVD;AAYA;EACC,sBAAA;EACA,0BAAA;AAVD;AAaA;EACE,YAAA;EAXA,8CAA8C;AAChD;ACxFC;;;EACC,8BAAA;EACA,yBAAA;AD4FF;AC7EC;;EAEC,eAAA;EACA,iCAAA;AD+EF;AC7EC;;;EAEC,cAAA;EACA,2BAAA;ADgFF;AC9EC;;EAEC,cAAA;EACA,gBAAA;ADgFF;ACvGA;EACE,yBAAA;EACA,cAAA;ADyGF;AATA;EACC,8BAAA;EACA,eAAA;AAWD;AARA;EACC,8BAAA;AAUD;AAPA;EACC,aAAA;AASD;AANA;EACC,eAAA;EACA,sBAAA;AAQD;AALA;;EAIC,yBAAA;EACA,qBAAA;AAKD;AAFA;EACC,qBAAA;AAID;AADA;EACC,yBAAA;AAGD;AAAA;;EAEC,yBAAA;EACA,gCAAA;AAED;AACA;EACC,oCAAA;AACD;AAEA;EACI,8BAAA;AAAJ;AAGA;EACI,8BAAA;AADJ;AAIA;EACI,wBAAA;AAFJ;AAKA;EACC,iBAAA;AAHD;AAMA;EACC,WAAA;AAJD;AAOA;EACC,oCAAA;EACA,yBAAA;AALD;AAQA;EACC,oCAAA;AAND;AASA;EACC,yBAAA;AAPD;AAUA;EACC,gCAAA;AARD","sourcesContent":["@import \"./theme\";\n\n* {\n\tpadding: 0;\n\tmargin: 0;\n\tbox-sizing: border-box;\n}\nbody {\n\tbackground-color: #333;\n}\n\n::-webkit-scrollbar {\n\twidth: 4px;\n\theight: 8px;\n}\n::-webkit-scrollbar-thumb {\n\tbackground-color: #888; /* Adjust the color as needed */\n\tborder-radius: 5px;\n}\n::-webkit-scrollbar-thumb:hover {\n\tbackground-color: #555; /* Adjust the hover color as needed */\n}\n::-webkit-scrollbar-track {\n\tbackground-color: #f1f1f1; /* Adjust the track color as needed */\n}\n\nbody {\n\tmargin: 0;\n\tpadding: 0;\n\tfont-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\",\n\t\t\"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n\tfont-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\n.ant-btn-default:not(:disabled):hover,\n.ant-btn-default:not(:hover):active {\n\tcolor: @primaryColor !important;\n\tborder-color: @primaryColor !important;\n}\n\n.ant-btn-primary {\n\tcolor: #fff;\n\tbackground-color: @primaryColor;\n}\n.ant-btn-primary:not(:disabled):active,\n.ant-btn-primary:not(:disabled):hover {\n\tcolor: #fff !important;\n\tbackground-color: rgb(71 203 56 / 80%) !important;\n}\n\n.ant-spin-dot-item, .ant-switch.ant-switch-checked {\n\tbackground-color: @primaryColor !important;\n}\n\n.ant-btn:disabled {\n\tbackground-color: #fff;\n\tcolor: rgba(0, 0, 0, 0.5);\n}\n.ant-pagination.ant-table-pagination {\n\tbackground: #fff;\n\tmargin: 0 !important;\n\tpadding: 16px 8px;\n}\n\n.ant-pagination-item,\n.ant-select.ant-pagination-options-size-changer:hover .ant-select-selector,\n.ant-input:hover,\n.ant-input:active,\n.ant-input:focus,\n.ant-upload-wrapper .ant-upload-drag:not(.ant-upload-disabled):hover,\n.ant-select:hover .ant-select-selector,\n.ant-input-outlined:hover {\n\tborder-color: @primaryColor !important;\n}\n\n.ant-pagination-item-active a,\n.ant-btn-link,\n.ant-tabs-tab-btn:active,\n.ant-tabs .ant-tabs-tab:hover,\n.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n\tcolor: @primaryColor !important;\n}\n\na {\n\tcolor: inherit !important;\n}\n\nbutton.unfilledDateButton {\n\tmargin: 1px;\n}\n\na.regular-link {\n\tcolor: blue !important;\n}\na.regular-link:hover {\n\tcolor: blue !important;\n\ttext-decoration: underline;\n}\n\n.ant-table-wrapper .ant-table.ant-table-small .ant-table-thead>tr>th {\n  padding: 1px; /* Even smaller padding for small size table */\n}\n\n\n// headers css is written in the thems.less file\n.header();\n\n.ant-layout-content {\n\tbackground: #333333 !important;\n\tpadding: 0 12px;\n}\n\n.ant-tabs .ant-tabs-ink-bar.ant-tabs-ink-bar-animated {\n\tbackground: @primaryColor !important;\n}\n\n#google-signin-div {\n\tpadding: 10px;\n}\n\n#google-logout-div {\n\tdisplay: inline;\n\tvertical-align: middle;\n}\n\n.ant-checkbox-checked .ant-checkbox-inner,\n.ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover\n\t.ant-checkbox-checked:not(.ant-checkbox-disabled)\n\t.ant-checkbox-inner {\n\tbackground-color: @primaryColor;\n\tborder-color: @primaryColor;\n}\n\n.ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner {\n\tborder-color: @primaryColor;\n}\n\n.ant-checkbox-indeterminate .ant-checkbox-inner:after {\n\tbackground-color: @primaryColor;\n}\n\n.ant-btn-default.ant-btn-dangerous:not(:disabled):not(.ant-btn-disabled):active,\n.ant-btn-default.ant-btn-dangerous:not(:disabled):not(.ant-btn-disabled):hover {\n\tcolor: #d9363e !important;\n\tborder-color: #d9363e !important;\n}\n\n.ant-btn-primary.ant-btn-dangerous:not(:disabled):not(.ant-btn-disabled):hover {\n\tbackground-color: #ff7875 !important;\n}\n\n.ant-table-wrapper .ant-table-tbody .ant-table-row.ant-table-row-selected >.ant-table-cell {\n    background: #e3ffe0 !important;\n}\n\n.ant-table-wrapper .ant-table-tbody .ant-table-row.ant-table-row-selected:hover >.ant-table-cell {\n    background: #cefdc9 !important;\n}\n\n.react-datepicker-popper {\n    z-index: 9999 !important;\n}\n\n.ant-segmented {\n\tbackground: black;\n}\n\n.ant-segmented-item-label {\n\tcolor: #fff;\n}\n\n.ant-segmented-item-selected {\n\tbackground-color: @primaryColor !important;\n\tcolor: #161010 !important;\n}\n\n.ant-segmented-thumb {\n\tbackground-color: @primaryColor !important;\n}\n\n.ant-select-dropdown .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n\tbackground-color: #d8fcd4;\n}\n\n.activeBorderColor {\n\tborder-color: @primaryColor !important;\n}\n@react-app-env: staging;","\n@primaryColor: #47cb38;\n@white-1: #ffffff;\n@black-1: #000000;\n@staging-header-color: #bb3b3b;\n\n.staging-main-ul() {\n\t.ant-menu-dark, .ant-menu-sub, .ant-layout-header {\n\t\tbackground: @staging-header-color !important;\n\t\tcolor: @white-1 !important;\n\t}\n}\n\n.google-logout() {\n#google-logout-button {\n\t\tbackground-color: @white-1;\n\t\tcolor: @black-1;\n\t}\n}\n\n.header() {\n\t& when(@react-app-env = staging) {\n\t\t.staging-main-ul();\n\t}\n\t.ant-menu-item,\n\t.ant-menu-title-content {\n\t\tfont-size: 16px;\n\t\ttransition: color 0.1s !important;\n\t}\n\t.ant-menu-submenu-selected,\n\t.ant-menu-item-selected, .ant-menu-item:active {\n\t\tcolor: if((@react-app-env = production), @primaryColor, @black-1);\n\t\tbackground: none !important;\n\t}\n\t.ant-menu-submenu-selected span,\n\t.ant-menu-item-selected span {\n\t\tcolor: if((@react-app-env = production), @primaryColor, @black-1);;\n\t\tfont-weight: 600;\n\t}\n\t& when(@react-app-env = staging) {\n\t\t.google-logout();\n\t}\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
